import React from 'react';

import * as CONFIG from 'constants/config';

const QuestionItem = ({question, index, categoryNameRu, currentPage}) => {
  const onClickDelete = (id) => {
    alert('TODO: step 2');
  };

  const num = (index + 1) + ((currentPage - 1) * CONFIG.COUNT_PER_PAGE);

	return (
		<tr>
      <td>{num}</td>
      <td>
        {categoryNameRu}
      </td>
      <td align="center">
        {question.image ? <img src={question.image} alt={question.id} width="100" /> : null}
        {question.typeImage === 'answer' ? 'В ответе' : null}
        {question.typeImage === 'question' ? 'В вопросе' : null}
      </td>
      <td>
        <div>
          <b>{question.name.en}</b>
          <br/>
          {question.lead.en}
        </div>
      </td>
      <td>
        <div>
          <b>{question.name.ru}</b>
          <br/>
          {question.lead.ru}
        </div>
      </td>
      <td>
        <div>
          <b>{question.name.uk}</b>
          <br/>
          {question.lead.uk}
        </div>
      </td>
      <td>
        <div>
          <b>{question.name.it}</b>
          <br/>
          {question.lead.it}
        </div>
      </td>
      <td>
        <div>
          <b>{question.name.pl}</b>
          <br/>
          {question.lead.pl}
        </div>
      </td>
      <td>
        <div>
          <b>{question.name.es}</b>
          <br/>
          {question.lead.es}
        </div>
      </td>
      <td>
        <div>
          <b>{question.name.pt}</b>
          <br/>
          {question.lead.pt}
        </div>
      </td>
      <td>
        <p>
          <a className="btn btn-warning btn-xs" href={`/questions/${question.id}`}>
            <i className="ace-icon fa fa-pencil-square-o bigger-110 icon-only"></i>
          </a>
          &nbsp;&nbsp;
          <button className="btn btn-grey btn-xs" onClick={() => onClickDelete(question.id)}>
            <i className="ace-icon fa fa-trash-o bigger-110 icon-only"></i>
          </button>
        </p>
      </td>
		</tr>
	);
};

export default QuestionItem;
